export default {
  domain: 'A',
  title: 'Verträglichkeit ',
  shortDescription: 'Verträglichkeit zeigt die individuellen Unterschiede für die Bereitschaft zur Kooperation für die soziale Harmonie. Menschen mit stark ausgeprägter Verträglichkeit ist es wichtig sich mit anderen zu verstehen.',
  description: `Daher sind sie rücksichtsvoll, freundlich, großzügig, 
hilfsbereit und zu Kompromissen für das Wohl anderer bereit.  
Wohltuende Personen haben ebenfalls eine optimistische Sichtweise auf die 
menschliche Natur. Sie glauben, dass Menschen ehrlich, anständig und 
vertrauenswürdig sind. <br /><br /> 
Unverträgliche Individuen stellen ihr eigenes Interesse über das soziale Wohl.
Das Wohlergehen anderer ist ihnen generell gleichgültig, damit ist es unüblich
für sie sich für das Wohl anderer zu verausgaben. Gelegentlich hat ihre Skepsis
zur Folge, dass sie von anderen als verdächtig, unfreundlich und nicht kooperativ 
gesehen werden.
<br /><br />
Verträglichkeit ist offensichtlich von Vorteil um Popularität zu erlangen und zu 
halten. Verträgliche Menschen sind eher beliebt als unverträgliche Menschen.
Andererseits ist Verträglichkeit nicht in Situationen hilfreich, in 
denen harte oder absolut objektive Entscheidungen gefällt werden müssen. 
Unverträgliche Menschen können exzellente Wissenschaftler, Kritiker und Soldaten sein.`,
  results: [
    {
      score: 'low',
      text: `Deine Punktzahl für Verträglichkeit ist niedrig, was auf weniger
Interesse auf das Wohl anderer als dein eigenes hindeutet. Leute sehen dich als
hart, kritisch und kompromisslos.`
    },
    {
      score: 'neutral',
      text: `Dein Verträglichkeitslevel ist normal, welches auf etwas Interesse
auf das Wohl anderer hindeutet. Allerdings würdest du dich nicht unbedingt für
das Wohl anderer aufopfern.`
    },
    {
      score: 'high',
      text: `Dein hohes Level an Verträglichkeit deutet auf ein starkes
Interesse für die Bedürfnisse anderer. Du wirst als angenehm, sympathisch
und kooperativ angesehen.`
    }
  ],
  facets: [
    {
      facet: 1,
      title: 'Vertrauen',
      text: `Eine Person mit ausgeprägtem Vertrauen geht davon aus, dass
die meisten Leute fair, ehrlich, und guter Dinge sind. Personen mit niedrigem
Vertrauen sehen andere als egoistisch, hinterhältig und potentiell gefährlich.`
    },
    {
      facet: 2,
      title: 'Moral',
      text: `Menschen mit hohen Punkten auf dieser Skala sehen keine Notwendigkeit
auf Manipulation oder Täuschung zu greifen, wenn sie es mit anderen 
Menschen zu tun haben und wirken aufrichtig, offen und ehrlich. Menschen mit
niedrigen Punktzahlen glauben, dass eine gewisse Unehrlichkeit in sozialen
Beziehungen dazugehört. Leute empfinden es als einfach sich mit einem Menschen
mit hoher Punktzahl zu verknüpfen. Generell finden es Leute schwer sich mit
einem Menschen mit wenigen Punkten zu verknüpfen. Hier sei gesagt, dass eine
niedrige Punktzahl nicht bedeutet, dass jene Menschen unmoralisch sind; sie
sind lediglich verschlossener und halten sich mehr bedeckt.`
    },
    {
      facet: 3,
      title: 'Altruismus',
      text: `Altruistische Leute finden den Akt des Helfens anderer als 
wirklich bereichernd. Infolgedessen sind sie generell gewillt anderen Menschen
in Not zu helfen. Altruistische Menschen empfinden es als eine Form von 
Selbsterfüllung statt Selbstaufopferung, wenn sie Leuten in Not helfen. Menschen
mit wenig Punkten in dieser Skala mögen es nicht besonders Menschen in Not zu
helfen. Sie sehen den Aufruf zur Hilfe eher als Zwang statt einer Chance
zur Selbsterfüllung.`
    },
    {
      facet: 4,
      title: 'Kooperation',
      text: `Individuen mit einer hohen Punktzahl in dieser Kategorie mögen
keine Konfrontationen. Sie sind durchaus zu einem Kompromiss bereit oder
stellen ihre eigenen Bedürfnisse für das Wohl anderer zurück. Jene Menschen 
mit einer niedrigen Punktzahl sind eher dazu veranlagt andere einzuschüchtern
um ihren Willen durchzusetzen.`
    },
    {
      facet: 5,
      title: 'Bescheidenheit',
      text: `Menschen mit hoher Punktzahl in dieser Skala geben nicht gerne
zu, dass sie besser als andere Leute sind. In einigen Fällen leitet sich
diese Einstellung von niedrigem Selbstbewusstsein oder Selbstwertgefühl ab.
Dennoch finden manche Leute mit hohem Selbstbewusstsein Unanständigkeit als
ungehörig. Diejenigen die gewillt sind sich als überlegen zu beschreiben, 
tendieren dazu von anderen Leuten als arrogant gesehen zu werden.`
    },
    {
      facet: 6,
      title: 'Sympathie',
      text: `Menschen mit einer hohen Punktzahl in dieser Skala sind 
weichherzig und mitfühlend. Sie empfinden viel Mitleid und lassen sich leicht
von diesem berühren. Menschen mit niedriger Punktzahl sind nicht stark von
menschlichem Leid betroffen. Sie sind stolz auf ihre auf Tatsachen begründeten
objektiven Entscheidungen. Sie sorgen sich mehr um Wahrheiten und
unparteiischer Gerechtigkeit als Mitleid.`
    }
  ]
};
